// ----------------------------------------------------------------------

export default function Accordion(theme) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          "&.Mui-expanded": {
            // boxShadow: theme.customShadows.z8,
            // borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.background.paper,
            borderTop: "1px solid rgba(0, 0, 0, .125)",
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(180deg)",
          },
          "& .MuiAccordionSummary-content": {
            marginLeft: theme.spacing(1),
            flexGrow: 0,
          },
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(1),
          justifyContent: "flex-start",
          "&.Mui-disabled": {
            opacity: 1,
            color: theme.palette.action.disabled,
            "& .MuiTypography-root": {
              color: "inherit",
            },
          },
        },
        expandIconWrapper: {
          color: "inherit",
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          borderTop: "1px solid rgba(0, 0, 0, .125)",
        },
      },
    },
  };
}
